export class FunctionalMap<K, V> extends Map<K, V> {
	deleteOrIgnore(key: K): this {
		super.delete(key);
		return this;
	}
	hasAndGet(key: K): V {
		const res = super.get(key);
		if (!res) {
			throw new Error(`Unknown element '${key}' in Map`);
		}
		return res;
	}
}
